module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core/navbar/navbar.component.scss
// module id = ./src/app/core/navbar/navbar.component.scss
// module chunks = main